import React from 'react'

import { SpinnerIcon } from 'icons'

import EmbedItem from './EmbedItem'
import css from './EmbedList.scss'

const EmbedList = ({ items, loading, showDateTime }) => {
  if (loading) {
    return (
      <div className={css.spinnerWrap}>
        <SpinnerIcon />
      </div>
    )
  }

  if (!items.length) {
    return <p className={css.empty}>No items to display.</p>
  }

  return (
    <div className={css.list}>
      {items.map((item) => (
        <EmbedItem
          key={item.key}
          title={item.title}
          href={item.href}
          kind={item.kind}
          start={item.start}
          end={item.end}
          facilitator={item.facilitator}
          showDateTime={showDateTime}
        />
      ))}
    </div>
  )
}

EmbedList.propTypes = {
  items: React.PropTypes.array.isRequired,
  loading: React.PropTypes.bool,
  showDateTime: React.PropTypes.bool
}

export default EmbedList
